import { reactive } from '#imports'

export type TileKey = string | number

const observerOptions = { rootMargin: '200px' }

export function useTileVisibility() {
    const mounted = reactive(new Set<TileKey>())
    const active = reactive(new Set<TileKey>())

    function setVisible(key: TileKey, isVisible: boolean) {
        if (isVisible) {
            mounted.add(key)
            active.add(key)
            return
        }

        active.delete(key)
    }

    function onTileVisible([entry]: IntersectionObserverEntry[]) {
        if (!entry) return

        const slug = (entry.target as HTMLElement).dataset.tileSlug
        if (!slug) {
            if (import.meta.dev) console.warn('[useTileVisibility] observed element has no data-tile-slug')

            return
        }

        setVisible(slug, entry.isIntersecting)
    }

    return { mounted, active, setVisible, onTileVisible, observerOptions }
}
